import React from 'react';
import LazyLoad from 'react-lazy-load';
import { Link } from 'react-router-dom';

import { Image } from '@app/objects/Image';
import { LinkBlockItemRich } from '@app/objects/LinkBlockItem';
import { addSubtitlesToYoutubeVideos } from '@app/utils/VideoExtensions';

import '@app/scss/components/linkBlockRich.scss';

interface LinkBlockRichProps {
	title: string | React.ReactElement;
	subtitle?: string;
	images: [Image, Image, Image];
	links?: Array<LinkBlockItemRich>;
	video?: string;
	srcYouTube?: string;
}

const LinkBlockRich: React.FC<LinkBlockRichProps> = (props) => (
	<section className="link-block-rich">
		<div className="link-block-rich__block-left">
			<div className="link-block-rich__wrapper">
				<header className="link-block-rich-header">
					{props.subtitle && <h6 className="link-block-rich-header__subtitle">{props.subtitle}</h6>}
					<h2 className="link-block-rich-header__title">{props.title}</h2>
				</header>
				<div className="link-block-rich-links">
					{props.links && (
						props.links.map((linkItem: LinkBlockItemRich, index: number) => (
							<Link to={linkItem.path} className="link-item" key={linkItem.name + index}>
								<div className="link-item-header">
									<img className="link-item-header__icon" src={linkItem.icon} alt={linkItem.alt} width={40} height={40} />
									<h5 className="link-item-header__title">{linkItem.name}</h5>
								</div>
								<div className="link-item-body">
									<p>{linkItem.text}</p>
									<span className="link-item-body__link">Learn more</span>
								</div>
							</Link>
						))
					)}
				</div>

				<div className="link-block-rich-links link-block-rich-links_mobile">
					{props.links && (
						props.links.map((linkItem: LinkBlockItemRich, index: number) => (
							<div className="link-item link-item_mobile" key={linkItem.name + index}>
								<div className="link-item-header">
									<img className="link-item-header__icon" src={linkItem.icon} alt="" width={40} height={40} />
									<h5 className="link-item-header__title">{linkItem.name}</h5>
								</div>
								<div className="link-item-body">
									<p>{linkItem.text}</p>
									<Link to={linkItem.path} className="link-item-body__link">
										Learn more
									</Link>
								</div>
							</div>
						))
					)}
				</div>
			</div>
		</div>
		<div className="link-block-rich__block-right">
			{!props.video && !props.srcYouTube && (
				<>
					<div className="link-block-rich-col">
						{props.images.slice(0, 2).map((image: Image, key: number) => (
							<div className="image-wrapper" key={key}>
								<LazyLoad offset={1000}>
									<img className="image-wrapper__img" src={image.src} alt={image.alt || ''} />
								</LazyLoad>
								<label className="image-wrapper__title">{image.title}</label>
							</div>
						))}
					</div>
					<div className="link-block-rich-col">
						<div className="image-wrapper">
							<LazyLoad offset={1000}>
								<img className="image-wrapper__img" src={props.images[2].src} alt={props.images[2].alt || ''} />
							</LazyLoad>
							<label className="image-wrapper__title">{props.images[2].title}</label>
						</div>
					</div>
				</>
			)}

			{props.video && (
				<LazyLoad offset={1000}>
					<video width="100%" controls>
						<source src={props.video} type="video/mp4" />
						Sorry, your browser doesn't support embedded videos.
					</video>
				</LazyLoad>
			)}

			{props.srcYouTube && (
				<div className="video-container">
					<LazyLoad offset={500}>
						<iframe
							src={addSubtitlesToYoutubeVideos(props.srcYouTube)}
							width="100%"
							height="100%"
							allow="fullscreen"
							allowFullScreen
							title="Lap of Love - Forever Home Commercial"
						/>
					</LazyLoad>
				</div>
			)}
		</div>
	</section>
);

export default LinkBlockRich;
